module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-pricing-form/e-novel-pricing-form.component.css
// module id = ./src/app/E-novels/e-novel-pricing-form/e-novel-pricing-form.component.css
// module chunks = main